/**
 * @generated SignedSource<<a99b2c8c4449b3ff92715abe1738170e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type CommentAuthorAssociation = "COLLABORATOR" | "CONTRIBUTOR" | "FIRST_TIMER" | "FIRST_TIME_CONTRIBUTOR" | "MANNEQUIN" | "MEMBER" | "NONE" | "OWNER" | "%future added value";
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type LockReason = "OFF_TOPIC" | "RESOLVED" | "SPAM" | "TOO_HEATED" | "%future added value";
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type ReactionContent = "CONFUSED" | "EYES" | "HEART" | "HOORAY" | "LAUGH" | "ROCKET" | "THUMBS_DOWN" | "THUMBS_UP" | "%future added value";
export type UserBlockDuration = "ONE_DAY" | "ONE_MONTH" | "ONE_WEEK" | "PERMANENT" | "THREE_DAYS" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useTimelineItemsFrontFragment$data = {
  readonly frontTimelineItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly __id: string;
        readonly actor?: {
          readonly __typename: string;
          readonly avatarUrl: string;
          readonly displayName?: string;
          readonly id: string;
          readonly isAgent?: boolean;
          readonly isCopilot?: boolean;
          readonly login: string;
          readonly name?: string | null | undefined;
          readonly profileResourcePath: string | null | undefined;
        } | null | undefined;
        readonly assignee?: {
          readonly __typename?: string;
          readonly displayName?: string;
          readonly id?: string;
          readonly isAgent?: boolean;
          readonly isCopilot?: boolean;
          readonly login?: string;
          readonly name?: string | null | undefined;
          readonly resourcePath?: string;
        } | null | undefined;
        readonly author?: {
          readonly __typename: string;
          readonly avatarUrl: string;
          readonly id: string;
          readonly login: string;
          readonly name?: string | null | undefined;
          readonly profileUrl: string | null | undefined;
        } | null | undefined;
        readonly authorAssociation?: CommentAuthorAssociation;
        readonly authorToRepoOwnerSponsorship?: {
          readonly createdAt: string;
          readonly isActive: boolean;
        } | null | undefined;
        readonly blockDuration?: UserBlockDuration;
        readonly blockedIssue?: {
          readonly __typename: "Issue";
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly stateReason: IssueStateReason | null | undefined;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined;
        readonly blockedUser?: {
          readonly login: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly blockingIssue?: {
          readonly __typename: "Issue";
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly stateReason: IssueStateReason | null | undefined;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined;
        readonly body?: string;
        readonly bodyHTML?: string;
        readonly bodyVersion?: string;
        readonly canonical?: {
          readonly __typename: "Issue";
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly stateReason: IssueStateReason | null | undefined;
          readonly titleHTML: string;
          readonly url: string;
        } | {
          readonly __typename: "PullRequest";
          readonly id: string;
          readonly isDraft: boolean;
          readonly isInMergeQueue: boolean;
          readonly number: number;
          readonly pullTitleHTML: string;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: PullRequestState;
          readonly url: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly closer?: {
          readonly __typename: "Commit";
          readonly abbreviatedOid: string;
          readonly repository: {
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly url: string;
        } | {
          readonly __typename: "ProjectV2";
          readonly title: string;
          readonly url: string;
        } | {
          readonly __typename: "PullRequest";
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly url: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly closingProjectItemStatus?: string | null | undefined;
        readonly color?: string | null | undefined;
        readonly commit?: {
          readonly abbreviatedOid: string;
          readonly message: string;
          readonly messageBodyHTML: string;
          readonly messageHeadlineHTML: string;
          readonly repository: {
            readonly defaultBranch: string;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly url: string;
        } | null | undefined;
        readonly createdAt?: string;
        readonly createdViaEmail?: boolean;
        readonly currentTitle?: string;
        readonly databaseId?: number | null | undefined;
        readonly deletedCommentAuthor?: {
          readonly __typename: string;
          readonly login: string;
          readonly name?: string | null | undefined;
        } | null | undefined;
        readonly discussion?: {
          readonly number: number;
          readonly url: string;
        } | null | undefined;
        readonly duplicate?: {
          readonly __typename: "Issue";
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly stateReason: IssueStateReason | null | undefined;
          readonly titleHTML: string;
          readonly url: string;
        } | {
          readonly __typename: "PullRequest";
          readonly id: string;
          readonly isDraft: boolean;
          readonly isInMergeQueue: boolean;
          readonly number: number;
          readonly pullTitleHTML: string;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: PullRequestState;
          readonly url: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly duplicateOf?: {
          readonly __typename: "Issue";
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly stateReason: IssueStateReason | null | undefined;
          readonly titleHTML: string;
          readonly url: string;
        } | {
          readonly __typename: "PullRequest";
          readonly id: string;
          readonly isDraft: boolean;
          readonly isInMergeQueue: boolean;
          readonly number: number;
          readonly pullTitleHTML: string;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: PullRequestState;
          readonly url: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly fromRepository?: {
          readonly nameWithOwner: string;
          readonly url: string;
        } | null | undefined;
        readonly id?: string;
        readonly innerSource?: {
          readonly __typename: "Issue";
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly stateReason: IssueStateReason | null | undefined;
          readonly titleHTML: string;
          readonly url: string;
        } | {
          readonly __typename: "PullRequest";
          readonly id: string;
          readonly isDraft: boolean;
          readonly isInMergeQueue: boolean;
          readonly number: number;
          readonly pullTitleHTML: string;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: PullRequestState;
          readonly url: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
        readonly intent?: {
          readonly rationale: string | null | undefined;
        } | null | undefined;
        readonly isCanonicalOfClosedDuplicate?: boolean | null | undefined;
        readonly isHidden?: boolean;
        readonly issue?: {
          readonly author: {
            readonly login: string;
          } | null | undefined;
          readonly databaseId: number | null | undefined;
          readonly id: string;
          readonly locked: boolean;
          readonly number: number;
        };
        readonly issueComment?: {
          readonly databaseId: number | null | undefined;
          readonly id: string;
          readonly url: string;
        } | null | undefined;
        readonly issueField?: {
          readonly dataType?: IssueFieldDataType;
          readonly name?: string;
        } | null | undefined;
        readonly issueType?: {
          readonly color: IssueTypeColor;
          readonly name: string;
        } | null | undefined;
        readonly label?: {
          readonly archivedAt: string | null | undefined;
          readonly color: string;
          readonly description: string | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly nameHTML: string;
        };
        readonly lastEditedAt?: string | null | undefined;
        readonly lastUserContentEdit?: {
          readonly editor: {
            readonly login: string;
            readonly url: string;
          } | null | undefined;
        } | null | undefined;
        readonly lockReason?: LockReason | null | undefined;
        readonly milestone?: {
          readonly id: string;
          readonly url: string;
        } | null | undefined;
        readonly milestoneTitle?: string;
        readonly minimizedReason?: string | null | undefined;
        readonly newColor?: string | null | undefined;
        readonly newOptions?: ReadonlyArray<{
          readonly color: string | null | undefined;
          readonly name: string;
        }> | null | undefined;
        readonly newValue?: string | null | undefined;
        readonly options?: ReadonlyArray<{
          readonly color: string | null | undefined;
          readonly name: string;
        }> | null | undefined;
        readonly parent?: {
          readonly __typename: "Issue";
          readonly databaseId: number | null | undefined;
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly stateReason: IssueStateReason | null | undefined;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined;
        readonly pendingBlock?: boolean | null | undefined;
        readonly pendingMinimizeReason?: string | null | undefined;
        readonly pendingUnblock?: boolean | null | undefined;
        readonly pinnedBy?: {
          readonly login: string;
        } | null | undefined;
        readonly prevIssueType?: {
          readonly color: IssueTypeColor;
          readonly name: string;
        } | null | undefined;
        readonly previousStatus?: string;
        readonly previousTitle?: string;
        readonly project?: {
          readonly title: string;
          readonly url: string;
        } | null | undefined;
        readonly reactionGroups?: ReadonlyArray<{
          readonly content: ReactionContent;
          readonly reactors: {
            readonly nodes: ReadonlyArray<{
              readonly __typename: string;
              readonly avatarUrl?: string;
              readonly displayName?: string;
              readonly isAgent?: boolean;
              readonly isCopilot?: boolean;
              readonly login?: string;
              readonly name?: string | null | undefined;
            } | null | undefined> | null | undefined;
            readonly totalCount: number;
          };
          readonly viewerHasReacted: boolean;
        }> | null | undefined;
        readonly referencedAt?: string;
        readonly relatedIssue?: {
          readonly __typename: "Issue";
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly stateReason: IssueStateReason | null | undefined;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined;
        readonly repository?: {
          readonly databaseId: number | null | undefined;
          readonly id: string;
          readonly isPrivate: boolean;
          readonly name: string;
          readonly nameWithOwner: string;
          readonly owner: {
            readonly id: string;
            readonly login: string;
            readonly url: string;
          };
          readonly slashCommandsEnabled: boolean;
          readonly viewerCanCreateIssues: boolean;
        };
        readonly showSpammyBadge?: boolean;
        readonly source?: {
          readonly __typename: string;
        };
        readonly stateReason?: IssueStateReason | null | undefined;
        readonly status?: string;
        readonly subIssue?: {
          readonly __typename: "Issue";
          readonly databaseId: number | null | undefined;
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly stateReason: IssueStateReason | null | undefined;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined;
        readonly subject?: {
          readonly __typename: "PullRequest";
          readonly isDraft: boolean;
          readonly isInMergeQueue: boolean;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: PullRequestState;
          readonly title: string;
          readonly url: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
        readonly url?: string;
        readonly value?: string | null | undefined;
        readonly viaApp?: {
          readonly name: string;
          readonly url: string;
        } | null | undefined;
        readonly viewerCanBlockFromOrg?: boolean;
        readonly viewerCanBlockPersonally?: boolean;
        readonly viewerCanDelete?: boolean;
        readonly viewerCanMinimize?: boolean;
        readonly viewerCanPin?: boolean;
        readonly viewerCanReadUserContentEdits?: boolean;
        readonly viewerCanReport?: boolean;
        readonly viewerCanReportToMaintainer?: boolean;
        readonly viewerCanUnblockFromOrg?: boolean;
        readonly viewerCanUnblockPersonally?: boolean;
        readonly viewerCanUndo?: boolean;
        readonly viewerCanUnminimize?: boolean;
        readonly viewerCanUnpin?: boolean;
        readonly viewerCanUpdate?: boolean;
        readonly viewerDidAuthor?: boolean;
        readonly willCloseSubject?: boolean;
        readonly willCloseTarget?: boolean;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number;
  };
  readonly id: string;
  readonly " $fragmentType": "useTimelineItemsFrontFragment";
};
export type useTimelineItemsFrontFragment$key = {
  readonly " $data"?: useTimelineItemsFrontFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTimelineItemsFrontFragment">;
};

import NewTimelinePaginationFrontQuery_graphql from './NewTimelinePaginationFrontQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "frontTimelineItems"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*:: as any*/),
    (v9/*:: as any*/),
    (v10/*:: as any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = [
  (v12/*:: as any*/)
],
v14 = {
  "kind": "InlineFragment",
  "selections": (v13/*:: as any*/),
  "type": "User",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v13/*:: as any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v13/*:: as any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v17 = [
  (v7/*:: as any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v22 = [
  (v2/*:: as any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v17/*:: as any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v5/*:: as any*/),
    (v12/*:: as any*/),
    (v20/*:: as any*/),
    (v25/*:: as any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v30 = [
  (v2/*:: as any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*:: as any*/),
      (v23/*:: as any*/),
      (v19/*:: as any*/),
      (v18/*:: as any*/),
      (v24/*:: as any*/),
      (v26/*:: as any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*:: as any*/),
      {
        "alias": "pullTitleHTML",
        "args": null,
        "kind": "ScalarField",
        "name": "titleHTML",
        "storageKey": null
      },
      (v19/*:: as any*/),
      (v18/*:: as any*/),
      (v27/*:: as any*/),
      (v28/*:: as any*/),
      (v29/*:: as any*/),
      (v26/*:: as any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v5/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archivedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameHTML",
      "storageKey": null
    },
    (v12/*:: as any*/),
    (v31/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rationale",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": (v17/*:: as any*/),
  "type": "Actor",
  "abstractKey": "__isActor"
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v36 = [
  (v5/*:: as any*/),
  (v2/*:: as any*/),
  (v7/*:: as any*/),
  (v35/*:: as any*/),
  (v12/*:: as any*/)
],
v37 = [
  (v5/*:: as any*/),
  (v7/*:: as any*/),
  (v35/*:: as any*/),
  (v12/*:: as any*/)
],
v38 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "milestoneTitle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v5/*:: as any*/),
      (v19/*:: as any*/)
    ],
    "storageKey": null
  }
],
v39 = [
  (v12/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dataType",
    "storageKey": null
  }
],
v40 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v39/*:: as any*/),
      "type": "IssueFieldText",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v39/*:: as any*/),
      "type": "IssueFieldDate",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v39/*:: as any*/),
      "type": "IssueFieldNumber",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v39/*:: as any*/),
      "type": "IssueFieldSingleSelect",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v39/*:: as any*/),
      "type": "IssueFieldMultiSelect",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v41 = [
  (v12/*:: as any*/),
  (v31/*:: as any*/)
],
v42 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v5/*:: as any*/),
      (v19/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "storageKey": null
  }
],
v43 = [
  (v5/*:: as any*/)
],
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviatedOid",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v12/*:: as any*/),
    (v25/*:: as any*/)
  ],
  "storageKey": null
},
v47 = [
  (v2/*:: as any*/),
  (v5/*:: as any*/),
  (v23/*:: as any*/),
  (v19/*:: as any*/),
  (v18/*:: as any*/),
  (v24/*:: as any*/),
  (v26/*:: as any*/)
],
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "blockingIssue",
  "plural": false,
  "selections": (v47/*:: as any*/),
  "storageKey": null
},
v49 = [
  (v5/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v47/*:: as any*/),
    "storageKey": null
  }
],
v50 = [
  (v5/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "relatedIssue",
    "plural": false,
    "selections": (v47/*:: as any*/),
    "storageKey": null
  }
],
v51 = [
  (v2/*:: as any*/),
  (v5/*:: as any*/),
  (v23/*:: as any*/),
  (v19/*:: as any*/),
  (v18/*:: as any*/),
  (v24/*:: as any*/),
  (v26/*:: as any*/),
  (v3/*:: as any*/)
],
v52 = [
  (v5/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v51/*:: as any*/),
    "storageKey": null
  }
],
v53 = [
  (v5/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v51/*:: as any*/),
    "storageKey": null
  }
],
v54 = [
  (v5/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v2/*:: as any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v44/*:: as any*/),
          (v19/*:: as any*/),
          (v18/*:: as any*/),
          (v27/*:: as any*/),
          (v28/*:: as any*/),
          (v29/*:: as any*/),
          (v46/*:: as any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v55 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "canonical",
  "plural": false,
  "selections": (v30/*:: as any*/),
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanonicalOfClosedDuplicate",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v44/*:: as any*/),
    (v19/*:: as any*/)
  ],
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v41/*:: as any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skip"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": NewTimelinePaginationFrontQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "useTimelineItemsFrontFragment",
  "selections": [
    {
      "alias": "frontTimelineItems",
      "args": [
        {
          "kind": "Variable",
          "name": "skip",
          "variableName": "skip"
        },
        {
          "kind": "Literal",
          "name": "visibleEventsOnly",
          "value": true
        }
      ],
      "concreteType": "IssueTimelineItemsConnection",
      "kind": "LinkedField",
      "name": "__Issue__frontTimelineItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueTimelineItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v3/*:: as any*/),
                    (v4/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "actor",
                      "plural": false,
                      "selections": [
                        (v5/*:: as any*/),
                        (v6/*:: as any*/),
                        (v7/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "profileResourcePath",
                          "storageKey": null
                        },
                        (v2/*:: as any*/),
                        (v11/*:: as any*/),
                        (v14/*:: as any*/),
                        (v15/*:: as any*/),
                        (v16/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "TimelineEvent",
                  "abstractKey": "__isTimelineEvent"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v3/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerDidAuthor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Issue",
                      "kind": "LinkedField",
                      "name": "issue",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "author",
                          "plural": false,
                          "selections": (v17/*:: as any*/),
                          "storageKey": null
                        },
                        (v5/*:: as any*/),
                        (v18/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "locked",
                          "storageKey": null
                        },
                        (v3/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "author",
                      "plural": false,
                      "selections": [
                        (v7/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "avatarUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "profileUrl",
                          "storageKey": null
                        },
                        (v5/*:: as any*/),
                        (v2/*:: as any*/),
                        (v14/*:: as any*/),
                        (v15/*:: as any*/),
                        (v16/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    (v5/*:: as any*/),
                    (v19/*:: as any*/),
                    (v4/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "authorAssociation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanDelete",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanMinimize",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanUnminimize",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanReport",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanReportToMaintainer",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanBlockFromOrg",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanUnblockFromOrg",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanBlockPersonally",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanUnblockPersonally",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanPin",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanUnpin",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "App",
                      "kind": "LinkedField",
                      "name": "viaApp",
                      "plural": false,
                      "selections": [
                        (v12/*:: as any*/),
                        (v19/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimizedReason",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showSpammyBadge",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdViaEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Sponsorship",
                      "kind": "LinkedField",
                      "name": "authorToRepoOwnerSponsorship",
                      "plural": false,
                      "selections": [
                        (v4/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isActive",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanReadUserContentEdits",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastEditedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "UserContentEdit",
                      "kind": "LinkedField",
                      "name": "lastUserContentEdit",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "editor",
                          "plural": false,
                          "selections": [
                            (v19/*:: as any*/),
                            (v7/*:: as any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "pinnedBy",
                      "plural": false,
                      "selections": (v17/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "body",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "unfurlReferences",
                          "value": true
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "bodyHTML",
                      "storageKey": "bodyHTML(unfurlReferences:true)"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bodyVersion",
                      "storageKey": null
                    },
                    {
                      "alias": "isHidden",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isMinimized",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanUpdate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Repository",
                      "kind": "LinkedField",
                      "name": "repository",
                      "plural": false,
                      "selections": [
                        (v5/*:: as any*/),
                        (v12/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "owner",
                          "plural": false,
                          "selections": [
                            (v5/*:: as any*/),
                            (v7/*:: as any*/),
                            (v19/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        (v20/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "viewerCanCreateIssues",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "slashCommandsEnabled",
                          "storageKey": null
                        },
                        (v21/*:: as any*/),
                        (v3/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ReactionGroup",
                      "kind": "LinkedField",
                      "name": "reactionGroups",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "content",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "viewerHasReacted",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "first",
                              "value": 10
                            }
                          ],
                          "concreteType": "ReactorConnection",
                          "kind": "LinkedField",
                          "name": "reactors",
                          "plural": false,
                          "selections": [
                            (v1/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "nodes",
                              "plural": true,
                              "selections": [
                                (v2/*:: as any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v7/*:: as any*/),
                                    (v12/*:: as any*/),
                                    (v6/*:: as any*/),
                                    (v11/*:: as any*/)
                                  ],
                                  "type": "Actor",
                                  "abstractKey": "__isActor"
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": "reactors(first:10)"
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "kind": "ClientExtension",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "pendingMinimizeReason",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "pendingBlock",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "pendingUnblock",
                          "storageKey": null
                        }
                      ]
                    }
                  ],
                  "type": "IssueComment",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "source",
                      "plural": false,
                      "selections": (v22/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "willCloseTarget",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referencedAt",
                      "storageKey": null
                    },
                    (v3/*:: as any*/),
                    {
                      "alias": "innerSource",
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "source",
                      "plural": false,
                      "selections": (v30/*:: as any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "CrossReferencedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v32/*:: as any*/),
                    (v5/*:: as any*/),
                    (v33/*:: as any*/)
                  ],
                  "type": "LabeledEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v32/*:: as any*/),
                    (v5/*:: as any*/)
                  ],
                  "type": "UnlabeledEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "assignee",
                      "plural": false,
                      "selections": [
                        (v34/*:: as any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": (v36/*:: as any*/),
                          "type": "User",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v36/*:: as any*/),
                          "type": "Mannequin",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v5/*:: as any*/),
                            (v2/*:: as any*/),
                            (v7/*:: as any*/),
                            (v35/*:: as any*/)
                          ],
                          "type": "Organization",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v5/*:: as any*/),
                            (v2/*:: as any*/),
                            (v7/*:: as any*/),
                            (v35/*:: as any*/),
                            (v8/*:: as any*/),
                            (v10/*:: as any*/),
                            (v9/*:: as any*/)
                          ],
                          "type": "Bot",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v33/*:: as any*/)
                  ],
                  "type": "AssignedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "assignee",
                      "plural": false,
                      "selections": [
                        (v2/*:: as any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": (v37/*:: as any*/),
                          "type": "User",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v5/*:: as any*/),
                            (v7/*:: as any*/),
                            (v35/*:: as any*/),
                            (v8/*:: as any*/),
                            (v10/*:: as any*/),
                            (v9/*:: as any*/)
                          ],
                          "type": "Bot",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v37/*:: as any*/),
                          "type": "Mannequin",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v5/*:: as any*/),
                            (v7/*:: as any*/),
                            (v35/*:: as any*/)
                          ],
                          "type": "Organization",
                          "abstractKey": null
                        },
                        (v34/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    (v5/*:: as any*/)
                  ],
                  "type": "UnassignedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v38/*:: as any*/),
                  "type": "MilestonedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v38/*:: as any*/),
                  "type": "DemilestonedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v40/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IssueFieldTimelineOption",
                      "kind": "LinkedField",
                      "name": "options",
                      "plural": true,
                      "selections": (v41/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    },
                    (v31/*:: as any*/),
                    (v33/*:: as any*/)
                  ],
                  "type": "IssueFieldAddedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v40/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "newColor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IssueFieldTimelineOption",
                      "kind": "LinkedField",
                      "name": "newOptions",
                      "plural": true,
                      "selections": (v41/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "newValue",
                      "storageKey": null
                    },
                    (v33/*:: as any*/)
                  ],
                  "type": "IssueFieldChangedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v40/*:: as any*/),
                    (v33/*:: as any*/)
                  ],
                  "type": "IssueFieldRemovedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v42/*:: as any*/),
                  "type": "IssueCommentPinnedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v42/*:: as any*/),
                  "type": "IssueCommentUnpinnedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v43/*:: as any*/),
                  "type": "SubscribedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v43/*:: as any*/),
                  "type": "UnsubscribedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v43/*:: as any*/),
                  "type": "MentionedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v3/*:: as any*/),
                    (v4/*:: as any*/),
                    (v24/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "duplicateOf",
                      "plural": false,
                      "selections": (v30/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "closingProjectItemStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "closer",
                      "plural": false,
                      "selections": [
                        (v2/*:: as any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v19/*:: as any*/),
                            (v44/*:: as any*/)
                          ],
                          "type": "ProjectV2",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v19/*:: as any*/),
                            (v18/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Repository",
                              "kind": "LinkedField",
                              "name": "repository",
                              "plural": false,
                              "selections": [
                                (v5/*:: as any*/),
                                (v12/*:: as any*/),
                                (v25/*:: as any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "PullRequest",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v19/*:: as any*/),
                            (v45/*:: as any*/),
                            (v46/*:: as any*/)
                          ],
                          "type": "Commit",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v5/*:: as any*/),
                    (v33/*:: as any*/)
                  ],
                  "type": "ClosedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v43/*:: as any*/),
                  "type": "ReopenedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lockReason",
                      "storageKey": null
                    },
                    (v5/*:: as any*/)
                  ],
                  "type": "LockedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v43/*:: as any*/),
                  "type": "UnlockedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v43/*:: as any*/),
                  "type": "PinnedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v43/*:: as any*/),
                  "type": "UnpinnedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "previousTitle",
                      "storageKey": null
                    }
                  ],
                  "type": "RenamedTitleEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    (v48/*:: as any*/)
                  ],
                  "type": "BlockedByAddedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v3/*:: as any*/),
                    (v5/*:: as any*/),
                    (v4/*:: as any*/),
                    (v48/*:: as any*/)
                  ],
                  "type": "BlockedByRemovedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v49/*:: as any*/),
                  "type": "BlockingAddedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v49/*:: as any*/),
                  "type": "BlockingRemovedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v50/*:: as any*/),
                  "type": "RelatesToAddedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v50/*:: as any*/),
                  "type": "RelatesToRemovedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "deletedCommentAuthor",
                      "plural": false,
                      "selections": [
                        (v2/*:: as any*/),
                        (v7/*:: as any*/),
                        (v14/*:: as any*/),
                        (v16/*:: as any*/),
                        (v15/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "CommentDeletedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "blockDuration",
                      "storageKey": null
                    },
                    (v5/*:: as any*/),
                    {
                      "alias": "blockedUser",
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "subject",
                      "plural": false,
                      "selections": [
                        (v7/*:: as any*/),
                        (v12/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "UserBlockedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v52/*:: as any*/),
                  "type": "SubIssueAddedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v52/*:: as any*/),
                  "type": "SubIssueRemovedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v53/*:: as any*/),
                  "type": "ParentIssueAddedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v53/*:: as any*/),
                  "type": "ParentIssueRemovedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "willCloseSubject",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "subject",
                      "plural": false,
                      "selections": (v22/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Commit",
                      "kind": "LinkedField",
                      "name": "commit",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "message",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "messageHeadlineHTML",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "messageBodyHTML",
                          "storageKey": null
                        },
                        (v19/*:: as any*/),
                        (v45/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Repository",
                          "kind": "LinkedField",
                          "name": "repository",
                          "plural": false,
                          "selections": [
                            (v12/*:: as any*/),
                            (v25/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "defaultBranch",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "ReferencedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v54/*:: as any*/),
                  "type": "ConnectedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Repository",
                      "kind": "LinkedField",
                      "name": "fromRepository",
                      "plural": false,
                      "selections": [
                        (v21/*:: as any*/),
                        (v19/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "TransferredEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v54/*:: as any*/),
                  "type": "DisconnectedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "duplicate",
                      "plural": false,
                      "selections": (v30/*:: as any*/),
                      "storageKey": null
                    },
                    (v55/*:: as any*/),
                    (v56/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanUndo",
                      "storageKey": null
                    }
                  ],
                  "type": "MarkedAsDuplicateEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v55/*:: as any*/),
                    (v56/*:: as any*/)
                  ],
                  "type": "UnmarkedAsDuplicateEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Discussion",
                      "kind": "LinkedField",
                      "name": "discussion",
                      "plural": false,
                      "selections": [
                        (v19/*:: as any*/),
                        (v18/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "ConvertedToDiscussionEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v3/*:: as any*/),
                    (v4/*:: as any*/),
                    (v57/*:: as any*/)
                  ],
                  "type": "AddedToProjectV2Event",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    (v57/*:: as any*/)
                  ],
                  "type": "RemovedFromProjectV2Event",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    (v57/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "previousStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    }
                  ],
                  "type": "ProjectV2ItemStatusChangedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v43/*:: as any*/),
                  "type": "ConvertedFromDraftEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    (v58/*:: as any*/),
                    (v33/*:: as any*/)
                  ],
                  "type": "IssueTypeAddedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    (v58/*:: as any*/)
                  ],
                  "type": "IssueTypeRemovedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*:: as any*/),
                    (v58/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IssueType",
                      "kind": "LinkedField",
                      "name": "prevIssueType",
                      "plural": false,
                      "selections": (v41/*:: as any*/),
                      "storageKey": null
                    },
                    (v33/*:: as any*/)
                  ],
                  "type": "IssueTypeChangedEvent",
                  "abstractKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v5/*:: as any*/)
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "9f5b31c52ed34b5943b9c468b106b7d6";

export default node;
